export default __webpack_public_path__ + "static/media/contact-pg.ed6d3060.png";